export class AssetsTypeModel
{
    public RefId : number;
    public AssetsName : string;
    public IsActive : boolean;
}